/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_ReceivedInputs */

const en_inbound_status_received = /** @type {(inputs: Inbound_Status_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Received`)
};

/**
* | output |
* | --- |
* | "Received" |
*
* @param {Inbound_Status_ReceivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_received = /** @type {((inputs?: Inbound_Status_ReceivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_ReceivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_received(inputs)
});